import { render, staticRenderFns } from "./BpbjStandardZyTable.vue?vue&type=template&id=4ea9a323&scoped=true&"
import script from "./BpbjStandardZyTable.vue?vue&type=script&lang=js&"
export * from "./BpbjStandardZyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea9a323",
  null
  
)

export default component.exports